const setItemStorage = (keyName, value) => {
  sessionStorage.setItem(keyName, value);
}

export default setItemStorage;
